export const filteredResources = (
  resourceData: any,
  listingData: any,
  setListingData: any,
  searchText: string,
  checkboxFilters: any,
  filtersAdded: any
) => {
  //* this means we haven't run init yet (like when doing the html rendering during createPage rendering)
  if (!listingData || listingData.length == 0) {
    setListingData(resourceData)
  }

  let filteredResourceData = [...listingData]

  if (searchText.length >= 3)
    filteredResourceData = filteredResourceData.filter(
      (resource: any) =>
        resource.body?.includes(searchText.toLowerCase()) ||
        resource.title?.toLowerCase().includes(searchText.toLowerCase())
    )

  const set = new Set()
  checkboxFilters.forEach((item: any) => {
    set.add(item.typename)
  })

  const filterMap: any = {}
  set.forEach((item: any) => {
    filterMap[item] = new Set()
  })

  for (let i = 0; i < filtersAdded.length; i++) {
    const filterGroup = filtersAdded[i]
    const filterValues: any = []

    if (filterGroup.filters.length !== 0) {
      let filterTypeName = ''
      const groupFilterItems = filterGroup.filters

      for (let i = 0; i < groupFilterItems.length; i++) {
        filterValues.push(groupFilterItems[i].value)
        filterTypeName = groupFilterItems[i].typename
      }

      filteredResourceData = filteredResourceData.filter((resource: any) => {
        if (resource[filterTypeName]) {
          return filterValues.some((item: any) => resource[filterTypeName].includes(item))
        } else {
          return false
        }
      })
    }
  }

  let topic: string
  let value: any

  filteredResourceData.forEach((resource: any) => {
    for ([topic, value] of Object.entries(filterMap)) {
      if (resource[topic]) {
        resource[topic].forEach((item: any) => {
          value.add(item)
        })
      }
    }
  })

  return [filteredResourceData, filterMap]
}
